import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Helpers from "../Helpers";
import { Paper, Grid, Button, Tooltip } from "@material-ui/core";
import design from "./css/Banner.module.css"
import { getApplicableInvestmentMinimum, getInvestmentEligibilityMessage, getVisibleEligibilityMessage } from "./investmentEligibility";
import * as ROUTES from "../../constants/route";

class FundCard extends Component {
  render() {
    const { funds, classes = {}, smBreakpoint, oneYrProgress, investDisabled } = this.props;
    this.helpers = new Helpers();
    let fundCards = null;

    if (funds.length === 0) {
      fundCards = (
        <div className="dark-label text-center">
          <label>No recommended funds based on your risk profile.</label>
        </div>
      );
      return fundCards;
    } else {
      fundCards = funds.map((fund, index) => {
        const eligibilityMessage = getInvestmentEligibilityMessage(fund, this.props.fundEligibility,
          getApplicableInvestmentMinimum(fund, this.props.investmentSummary));
        const disabled = investDisabled || !!eligibilityMessage;
        const visibleEligibilityMessage = getVisibleEligibilityMessage(eligibilityMessage);
        const requiresFullVerification = fund.fundType === "UITF" && this.props.fundEligibility?.data?.tier === 2;
        return (
          <Paper elevation={4} className="suggested-box" key={index} style={{ display: "flex", flexDirection: "column" }}>
            <div className="relative" style={{ flex: 1, display: "flex", flexDirection: "column" }}>
              <Grid
                container
                alignItems="center"
                className={classes.recommendedInvestCardTitle}
                style={{
                  fontFamily: "sans-serif",
                  textTransform: "uppercase",
                  minHeight: TWO_LINE_TITLE_HEIGHT,
                }}
              >
                <Grid item xs>
                  <div style={TWO_LINE_TITLE_CLAMP}>{fund.name}</div>
                </Grid>
                {fund.banner === undefined
                  ? ""
                  : fund.banner.enabled && (
                      <Grid
                        item
                        style={
                          fund.name.length <= 33
                            ? { marginLeft: "100px" }
                            : { marginLeft: "90px" }
                        }
                      >
                        <span
                          className={design.ribbon}
                          style={{
                            background: fund.banner.color,
                            color: fund.banner.textColor,
                            fontWeight: "900",
                            top: top,
                          }}
                        >
                          {fund.banner.text}
                        </span>
                      </Grid>
                    )}
              </Grid>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  margin: "30px",
                }}
              >
                <div className={`indicator ${fund.riskType}`}>
                  {`For ${fund.riskType}-type of investor`}
                </div>
              </div>
              {smBreakpoint ? (
                <div>
                  <div className="d-flex">
                    <span>{`NAVPU as of ${fund.date}`}</span>
                    <span className={`text-gold`}>
                      {this.helpers.formatToPHP(fund.pricePerShare, 4)}
                    </span>
                  </div>
                  <div className="d-flex">
                    <span>Year-to-Date Return</span>
                    <span
                      className={`text-${
                        fund.ytd * 100 > 0
                          ? "ytd-above"
                          : fund.ytd * 100 < 0
                          ? "ytd-below"
                          : "gold"
                      }`}
                    >
                      {parseFloat(fund.ytd * 100).toFixed(2)}%
                    </span>
                  </div>
                  {oneYrProgress && (
                    <div className="d-flex">
                      <span>1-Year Return</span>
                      <span className={`text-gold`}>
                        {fund.oneyrprogress === "n/a" ||
                        Math.abs(fund.oneyrprogress) < 1e-10 ||
                        fund.oneyrprogress === ""
                          ? "N/A"
                          : `${parseFloat(fund.oneyrprogress * 100).toFixed(
                              2
                            )}%`}
                      </span>
                    </div>
                  )}
                </div>
              ) : (
                <table>
                  <tbody>
                    <tr>
                      <td>{`NAVPU as of ${this.helpers.dateFormat(
                        fund.date
                      )}`}</td>
                      <td className={`text-gold`}>
                        {this.helpers.formatToPHP(fund.pricePerShare, 4)}
                      </td>
                    </tr>
                    <tr>
                      <td>Year-to-Date Return</td>
                      <td
                        className={`text-${
                          fund.ytd * 100 > 0
                            ? "ytd-above"
                            : fund.ytd * 100 < 0
                            ? "ytd-below"
                            : "gold"
                        }`}
                      >
                        {parseFloat(fund.ytd * 100).toFixed(2)}%
                      </td>
                    </tr>
                    {oneYrProgress && (
                      <tr>
                        <td>1st Yr. Return</td>
                        <td className={`text-gold`}>
                          {fund.oneyrprogress === "n/a" ||
                          Math.abs(fund.oneyrprogress) < 1e-10 ||
                          fund.oneyrprogress === ""
                            ? "N/A"
                            : parseFloat(fund.oneyrprogress * 100).toFixed(2)}
                          %
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              )}

              <Grid
                container
                direction="row"
                justifyContent="space-evenly"
                alignItems="center"
                style={{ marginTop: "auto" }}
              >
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <div className={classes.recommendedInvestCardButton}>
                    <Button
                      color="primary"
                      variant="outlined"
                      onClick={() =>
                        this.props.redirectFund(fund.id, fund.riskType, false, fund.isDividend)
                      }
                      fullWidth
                    >
                      <span className={classes.recommendedInvestCardText}>
                        Learn More
                      </span>
                    </Button>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <div className={classes.recommendedInvestCardButton}>
                    {requiresFullVerification ? (
                      <Tooltip title={visibleEligibilityMessage} arrow enterTouchDelay={0}>
                        <Button
                          variant="contained"
                          color="primary"
                          style={{ color: "white" }}
                          onClick={() => this.props.history.push(ROUTES.LONG_KYC_LAST)}
                          fullWidth
                        >
                          <span className={classes.recommendedInvestCardText}>
                            Get Fully Verified
                          </span>
                        </Button>
                      </Tooltip>
                    ) : (
                      <Tooltip title={disabled ? visibleEligibilityMessage : ""} arrow enterTouchDelay={0}>
                        {/* Disabled buttons emit no pointer events, so the tooltip anchors to this wrapper */}
                        <span tabIndex={disabled && visibleEligibilityMessage ? 0 : undefined} style={{ display: "block", width: "100%" }}>
                          <Button
                            disabled={disabled}
                            variant="contained"
                            color="primary"
                            style={{
                              color: disabled ? "#ABABAB" : "white",
                              backgroundColor: disabled ? "#C4C4C4" : undefined
                            }}
                            onClick={() =>
                              this.props.redirectFund(fund.name, fund.riskType, true, fund.isDividend)
                            }
                            fullWidth
                          >
                            <span className={classes.recommendedInvestCardText}>
                              Invest Now
                            </span>
                          </Button>
                        </span>
                      </Tooltip>
                    )}
                  </div>
                </Grid>
              </Grid>
            </div>
          </Paper>
        );
      });
    }

    return <div className="flexbox">{fundCards}</div>;
  }
}

const TWO_LINE_TITLE_HEIGHT = "60px";

const TWO_LINE_TITLE_CLAMP = {
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
};

export default withRouter(FundCard);
